import { NativeDashboards } from "./NativeDashboards";

export const nativeDashboardsRoutes = [
    {
        path: "/native_dashboards",
        element: <NativeDashboards />,
    },
];
